import { format, toDate } from "src/utils/dayjs";

import Base from "./base.model";
import {
  PurchaseProposalFormGoods,
  PurchaseProposalFormPreviewGoods,
} from "./good.model";
import {
  PurchaseProposalFormMaterials,
  PurchaseProposalFormPreviewMaterials,
  PurchaseProposalFormPrintMaterials,
} from "./material.model";

//note: 0: pending | 1: Đã Duyệt | 2: Từ chối
//note: confirmedStatus: Kho Trung Tâm | approvedStatus: Chi Nhánh
const STATUS = {
  0: { color: "warning", text: "Mới tạo", status: 0 },
  1: { color: "success", text: "Đã duyệt", status: 1 },
  2: { color: "danger", text: "Từ chối", status: 2 },
};

const mapStatus = (approvedStatus, confirmedStatus) => {
  if (confirmedStatus === 1) return STATUS[1];
  if (confirmedStatus === 2)
    return { ...STATUS[2], text: "Kho trung tâm từ chối" };

  if (approvedStatus === 0) return STATUS[0];
  if (approvedStatus === 1)
    return { ...STATUS[0], text: "Chờ kho trung tâm duyệt" };
  if (approvedStatus === 2) return { ...STATUS[2], text: "Chi nhánh từ chối" };

  return STATUS[0];
};

export class PurchaseProposalForms extends Base {
  constructor({
    storeName,
    creator,
    issueDate,
    approvedStatus,
    confirmedStatus,
    reason,
    total,
    createdBy,
    role_name,
    roleName,
    ...rest
  }) {
    super(rest);

    const { status, color, text } = mapStatus(approvedStatus, confirmedStatus);

    Object.assign(this, {
      storeName: storeName,
      createdBy: createdBy,
      creator: creator,
      issueDate: format(issueDate),
      status: status,
      status_text: text,
      status_color: color,
      waiting_central: !!(approvedStatus === 1 && confirmedStatus === 0),
      reason: reason,
      total: total,
      role_name: role_name || roleName,
    });
  }
}

export class PurchaseProposalForm extends Base {
  constructor({
    store_code,
    storeName,
    storeAddress,
    storePhone,
    issueDate,
    reason,
    total,
    goods,
    materials,
    ...rest
  }) {
    super(rest);

    Object.assign(this, {
      storeName: storeName,
      store_code: store_code,
      storeAddress: storeAddress,
      storePhone: storePhone,
      issueDate: toDate(issueDate),
      reason: reason,
      total: total,
      goods: goods?.map((g) => new PurchaseProposalFormGoods(g)) ?? [],
      materials:
        materials?.map((m) => new PurchaseProposalFormMaterials(m)) ?? [],
    });
  }
}

export class PurchaseProposalFormPreview extends Base {
  constructor({
    store_code,
    storeName,
    storeAddress,
    storePhone,
    issueDate,
    reason,
    total,
    goods,
    materials,
    ...rest
  }) {
    super(rest);

    Object.assign(this, {
      storeName: storeName,
      store_code: store_code,
      storeAddress: storeAddress,
      storePhone: storePhone,
      issueDate: toDate(issueDate),
      reason: reason,
      total: total,
      goods: goods?.map((g) => new PurchaseProposalFormPreviewGoods(g)) ?? [],
      materials:
        materials?.map((m) => new PurchaseProposalFormPreviewMaterials(m)) ??
        [],
    });
  }
}

export class PurchaseProposalFormPrints extends Base {
  constructor({
    storeName,
    store_code,
    storeAddress,
    storePhone,
    reason,
    total,
    materials,
    createdDate,
    date,
    ...rest
  }) {
    super(rest);

    Object.assign(this, {
      storeName: storeName,
      store_code: store_code,
      storeAddress: storeAddress,
      storePhone: storePhone,
      reason: reason,
      total: total,
      createdDate,
      date,
      materials:
        materials?.map((m) => new PurchaseProposalFormPrintMaterials(m)) ?? [],
    });
  }
}
